import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Body {
  type: string;
  attrs: {
    text: string;
    author?: string; // Optional for quotes
  };
  order: number;
}

interface Section {
  title: string;
  body: Body[];
  order: number;
}

interface Blog {
  title: string;
  sections: Section[];
  coverImage: string;
}

interface Pagination {
  page: number;
  limit: number;
  totalCount: number;
}

type initialStateType = {
  blogs: Blog[];
  blog: Object;
  blogInfo: {};
  isLoading: boolean;
  errors: string | null;
  pagination: Pagination;
};

export const initialState: initialStateType = {
  blogs: [],
  blog: {},
  blogInfo: {},
  isLoading: false,
  errors: null,
  pagination: {
    page: 1,
    limit: 10,
    totalCount: 0,
  },
};

const BlogSlice = createSlice({
  name: "Blog",
  initialState,
  reducers: {
    setIsLoading: (state: initialStateType, action: { payload: boolean }) => {
      state.isLoading = action.payload;
    },
    setPagination: (state, action: { payload: Pagination }) => {
      state.pagination = action.payload;
    },
    createBlogSuccess(state, action: PayloadAction<Blog>) {
      // state.loading = false;
      state.blogs.push(action.payload);
    },
    createBlogFailure(state, action: PayloadAction<string>) {
      // state.loading = false;
      state.errors = action.payload;
    },
    setBlogInfo: (state, action: { payload: any }) => {
      // Merge new payload values, including adding products if provided
      state.blogInfo = {
        ...state.blogInfo,
        ...action.payload,
        // products: [
        //   ...(state.discountInfo.products || []), // Existing products
        //   ...(action.payload.products || []), // New products from payload
        // ],
      };
    },
    getBlogsSuccess: (state: initialStateType, action: any) => {
      state.blogs = action.payload;
    },
    getBlogsError: (state: initialStateType, action: any) => {
      state.errors = action.payload;
    },
    getBlogByIdSuccess: (state: initialStateType, action: any) => {
      state.blog = action.payload;
    },
    getBlogByIdError: (state: initialStateType, action: any) => {
      state.errors = action?.payload || null;
    },
    updateBlogSuccess: (state: initialStateType, action: any) => {
      state.blogs = state.blogs.map((blog: any) =>
        blog._id === action.payload._id
          ? { ...blog, ...action.payload }
          : blog
      );
    },
    updateBlogError: (state: initialStateType, action: any) => {
      state.errors = action.payload;
    },
    deleteBlogSuccess: (state: initialStateType, action: any) => {
      state.blogs = state.blogs.filter(
        (blog: any) => blog._id !== action.payload
      );
    },
    deleteBlogError: (state: initialStateType, action: any) => {
      state.errors = action?.payload || null;
    },
  },
});

export default BlogSlice.reducer;
export const {
  createBlogSuccess,
  createBlogFailure,
  setBlogInfo,
  getBlogsSuccess,
  getBlogsError,
  setIsLoading,
  getBlogByIdSuccess,
  getBlogByIdError,
  updateBlogSuccess,
  updateBlogError,
  setPagination,
  deleteBlogSuccess,
  deleteBlogError
} = BlogSlice.actions;
